import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Complain} from './model/complain';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ComplainRegisterService {
  //Local
 // PHP_API_SERVER = 'http://192.168.64.2/backend';

  //Hostinger
  PHP_API_SERVER = '/backend';

    constructor(private httpClient: HttpClient) {
    }

    createComplain(complain: Complain) {
      console.log(complain);
    var url = this.PHP_API_SERVER + '/connect.php';
    return this.httpClient.post<any>(`${url}`, complain);
  }

  getComplain(complId: string, phone: string, aadhar: string) {

    var url = null;
    if(complId) {
      url = this.PHP_API_SERVER + '/read.php?complId=' + complId;
    } else {
      url = this.PHP_API_SERVER + '/read.php?phone=' + phone
      + '&aadhar=' + aadhar;
    }
    return this.httpClient.get<Complain[]>(url);
  }

  public extracted(value: string) {
    var subCates: any = [];
    if (value == 'Choose ...') {
      subCates = [];
    }
    if (value == 'Housing') {
      subCates = ['Sanctioned first installment not released',
      'Geo tagged but second installment not released',
      'Geo tagged but third installment not released',
      'Inspection and Geo tag not done for second and third installment',
      'Final payment is not released',
      'MGNREGA wages not released',
      'Technical support required'];
    }
    if (value == 'Water') {
      subCates = ['Tubewell repairing required',
        'New tubewell required',
      'Sanitation of water is poor'];
    }
    if (value == 'Harischandra Sahayata') {
      subCates = ['Payment is not received within 10 days of submission of application',
        'Payment is not received after 1 month',
        'Payment is less as per govt guideline'];
    }
    if (value == 'PDS') {
      subCates = ['Applied for ration card but not received',
        'Weight of commodity is less',
        'Extra money changed for commodity',
       'Refused t0 issue card for commodity',
      'Card is lost, applied for new card'];
    }

    if (value == 'MGNREGA') {
      subCates = ['Work is in progress without dispay board',
        'Work is done without approval of gramsabha',
        'Working but not getting wage',
        'Payment is in cash',
        'Payment is less in comparison to workdone',
        'Job card is not up to date',
        'Applied for work but no engagement so far',
        'PM is not done',
        'Applied for work but got refused',
        'Applied for job card but not issued even after 7 days'
      ];
    }
    return subCates;
  }

}
